/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_NoneInputs */

const cs_chat_attach_none = /** @type {(inputs: Chat_Attach_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez přílohy`)
};

const en_chat_attach_none = /** @type {(inputs: Chat_Attach_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No attachment`)
};

/**
* | output |
* | --- |
* | "No attachment" |
*
* @param {Chat_Attach_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_none = /** @type {((inputs?: Chat_Attach_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_none(inputs)
	return cs_chat_attach_none(inputs)
});